module.exports = __webpack_public_path__ + "img/settings-a1c79201dce2c852ac5e376e15db2ca2.svg";